/**
 * Class for logging page views to ACM server.
 */
export default class UsageLogger {
  /**
   * Passes data to `/usage-logger` which then sends a HEAD request to ACM for logging page views.
   */
  logPageView() {
    window.onload = () => {
      const {
        nonce, type, id, doi,
      } = window.amScripts['usage-logger'];

      if (type !== 'digital-library' && type !== 'issue') {
        return;
      }

      if (!nonce || !id || !doi) {
        return;
      }

      // Append parameters to URL.
      this.params = new URLSearchParams();
      this.params.append('nonce', nonce);
      this.params.append('id', id);
      this.params.append('doi', doi);

      fetch(
        `/usage-logger?${this.params.toString()}`,
        {
          cache: 'no-cache',
        },
      );
    };
  }
}
